<template>
    <div class="polls">
      <div v-if="attachment.Poll" class="content-area" :class="{'content-area-form' : isRegitrationFormQuestion}">
        <p class="has-text-danger required-fields">(&#42; = {{$t('yscCheck.required')}})</p>
        <div class="title" qa="poll_title">{{ attachment.Poll.question }}<span v-if="attachment.Poll.isRequired" class="has-text-danger">&#42;</span></div>
        <div v-if="showQuestions && !showAnswers" :class="{ 'disabled': isPollDisabled }">
          <!-- Check question type -->
          <span v-if="isText">
            <div class="column poll text">
              <input class="question input"
                     type="string"
                     placeholder="Please answer the question"
                     value=""
                     v-model="formQuestion"
                     qa="poll-question-input"/>
            </div>
          </span>
          <div v-else>
            <div v-if="isPoll">
              <div v-for="(option) in attachment.Poll.options"
                   class="column poll text"
                   :key="option.id">
                <!-- Polls -->
                <div  class="selection-area cursor-pointer is-flex"
                      @click="selectedOpts(option, attachment.Poll.questionType)"
                      :key="option.option">
                  <i :class="{
                    'checkmark fal fa-circle' : isRadio && option.id !== selectedUserOption,
                    'checkmark has-text-primary fal fa-check-circle' : isRadio && option.id === selectedUserOption
                  }"
                  />
                  <div qa="option_txt">&nbsp;{{ option.option }}</div>
                </div>
              </div>
            </div>
            <!-- Form -->
            <div v-else class="poll-drop-down">
              <v-select v-if="isMulti"
                        placeholder="Please select all that apply"
                        multiple
                        :options="attachment.Poll.options"
                        label="option"
                        :reduce="(option) => option.id"
                        class="dropdown-text"
                        v-model="selectedUserOptions">
              </v-select>
              <v-select v-else
                        placeholder="Please select one that applies"
                        single
                        :options="attachment.Poll.options"
                        label="option"
                        :reduce="(option) => option.id"
                        class="dropdown-text"
                        v-model="selectedUserOption">
              </v-select>
            </div>
          </div>
          <div v-if="!isAdminJudge && !isPollDisabled" class="has-text-centered">
            <button class="save-button is-medium button is-primary"
                    :disabled="!selectedUserOption && !formQuestion.length && !selectedUserOptions.length"
                    :class="{ 'disabled': isPollDisabled }"
                    @click="checkLoggedIn">
              {{ hasAnswers ? $t('saveEdit').toUpperCase() : $t('save').toUpperCase() }}
            </button>
          </div>
        </div>
        <div v-if="showAnswers" class="results">
          <div v-for="option in attachment.Poll.options" :key="option.id">
            <span class="is-flex answer">
              <p class="has-text-primary percent">{{calculatePercentage(option.id)}}%</p>
              <span>
                <progress class="progress is-primary"
                          :value="optionTotal[option.id] ? optionTotal[option.id] : 0 "
                          :max="total" />
                <div class="progress-text">{{option.option}}</div>
                <div class="has-text-primary total" > {{optionTotal[option.id] ? optionTotal[option.id] : 0}}
                  <div class="total"> &nbsp; vote(s) </div>
                </div>
              </span>
            </span>
          </div>
          <div class="total-results"> {{ total }} &nbsp; Total votes
          </div>
        </div>
        <loader :loading="!showAnswers && !showQuestions" />
      </div>
      <div v-else>
        <div class="title">{{ attachment.question }}</div>
          <div v-for="option in attachment.pollOptions" :key="option.id">
            <span class="selection-area cursor-pointer is-flex" @click="selectedUserOption = option.id">
              <i :class="{
                    'checkmark fal fa-circle' : attachment.questionType == 'radio',
                    'checkmark fal fa-square' : attachment.questionType == 'multi'
                  }"></i>
              <div>{{ option.option }}</div>
            </span>
          </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import auth from '@/mixins/auth'
import Loader from '@/components/Base/Loader/loader'
import displayTypes from '@/mixins/project-display-types'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

Vue.component('v-select', vSelect)

export default {
  props: {
    attachment: {
      type: Object,
      required: true
    },
    selectDot: {
      type: Function
    },
    position: {
      type: Number
    },
    getPostDirection: {
      type: Function
    },
    lengthOfAttach: {
      type: Number
    }
  },
  components: { Loader },
  mixins: [auth, displayTypes],
  data: function () {
    return {
      selectedUserOption: null,
      selectedUserOptions: [],
      answers: [],
      hasAnswers: false,
      total: 0,
      optionTotal: [],
      showQuestions: false,
      formQuestion: '',
      hasPassedZero: false
    }
  },
  mounted: function () {
    if (this.attachment.Poll) {
      this.$nextTick(() => {
        this.getUserAnswer()
      })
    }
    this.hasPassedZero = false
  },
  computed: {
    showAnswers: function () {
      return this.answers !== null && this.answers.length !== 0 && !this.isRegitrationFormQuestion
    },
    isRadio: function () {
      return this.attachment.Poll.questionType === 'radio'
    },
    isMulti: function () {
      return this.attachment.Poll.questionType === 'multi'
    },
    isText: function () {
      return this.attachment.Poll.questionType === 'text'
    },
    isPoll: function () {
      return this.attachment.Poll.type === 'publicproject'
    },
    isRegitrationFormQuestion: function () {
      return this.attachment.Poll.type === 'registrationform'
    },
    isProjectSubmitted: function () {
      const post = this.$store.getters.getPost(this.attachment.postID)
      return this.$store.getters.isProjectSubmitted(post.projectID)
    },
    isPollDisabled: function () {
      return this.isProjectSubmitted && this.isRegitrationFormQuestion
    },
    isRegistrationFormProject: function () {
      return this.project.displayType === this.DisplayTypeRegistrationForm
    },
    project: function () {
      const post = this.$store.getters.getPost(this.attachment.postID)
      return this.$store.getters.project(post.projectID)
    },
    isOwner: function () {
      return this.project.user.id === this.currentUser.id
    },
    isAdminJudge: function () {
      return this.currentUser.isJudgingAdmin
    }
  },

  methods: {
    selectedOpts: function (option, questionType) {
      switch (questionType) {
        case 'radio':
          this.selectedUserOption = option.id
          break
        default:
          if (this.selectedUserOptions.includes(option.id)) {
            this.selectedUserOptions.splice(this.selectedUserOptions.indexOf(option.id), 1)
          } else {
            this.selectedUserOptions.push(option.id)
          }
          break
      }
    },
    calculatePercentage: function (optionID) {
      if (!this.optionTotal[optionID]) {
        return 0
      }

      return Math.round((this.optionTotal[optionID] / this.total) * 100)
    },
    getUserAnswer: function () {
      if (!this.isLoggedIn) {
        this.showQuestions = true
        return
      }
      const params = {
        pollID: this.attachment.Poll.id,
        userID: this.project.user.id,
        projectID: this.project.id
      }
      if (this.attachment.Poll.type === 'registrationform') {
        if (!this.isOwner && (this.isAdmin || this.projectRole === 'anonAdmin' || this.isJudgeAdmin)) {
          this.$store.dispatch('getOtherUserAnswers', params).then((response) => {
            this.processUserAnswers(response)
          }).finally(() => {
            this.showQuestions = true
          })
        } else {
          this.$store.dispatch('getUserAnswers', params).then((response) => {
            this.processUserAnswers(response)
          }).finally(() => {
            this.showQuestions = true
          })
        }
      } else {
        this.$store.dispatch('getUserAnswer', params).then((response) => {
          this.total = 0
          this.answers = response.data.result.answers
          if (this.answers !== null) {
            this.answers.forEach((answer) => {
              this.total += answer.count
              this.optionTotal[answer.optionID] = answer.count
            })
          }
          this.hasAnswers = this.answers !== null
          this.showQuestions = true
        }, () => {
          this.showQuestions = true
        })
      }
    },
    processUserAnswers: function (response) {
      this.answers = response.data.result.answers.map(m => {
        return {
          ...m.option,
          optionID: m.option.id
        }
      })
      // Restore the select options
      if (this.answers && this.answers.length > 0) {
        if (this.isRadio) {
          this.selectedUserOption = this.answers[0].optionID
        } else if (this.isMulti) {
          this.selectedUserOptions = this.answers.map(m => m.optionID)
        } else {
          this.formQuestion = response.data.result.answers[0].answer
        }
      }
      this.hasAnswers = this.answers !== null && this.answers.length > 0
    },
    checkLoggedIn: function () {
      if (!this.isLoggedIn) {
        this.$store.dispatch('showLoginModal', { source: 'SUBMITPOLL', onSuccess: this.saveUserOption, signupMessage: 'Sign up to save your poll selection' })
      } else {
        this.saveUserOption()
      }
    },
    saveUserOption: function () {
      const params = {
        pollID: this.attachment.Poll.id,
        optionID: this.selectedUserOption ? this.selectedUserOption : 0,
        answer: this.formQuestion,
        options: this.selectedUserOptions,
        userID: this.project.user.id,
        projectID: this.project.id
      }
      if (!this.isOwner && (this.isAdmin || this.projectRole === 'anonAdmin')) {
        this.$store.dispatch('saveOtherUserOption', params).then((response) => {
          this.processSaveUserResponse(response)
        }, () => {
          // @todo handle errors
        })
      } else {
        const post = this.$store.getters.getPost(this.attachment.postID)
        this.$store.dispatch('saveUserOption', params).then((response) => {
          this.processSaveUserResponse(response)
          this.$store.dispatch('fetchPollUserOptions', { projectId: post.projectID })
        }, () => {
          // @todo handle errors
        })
      }

      if (this.isRegistrationFormProject) {
        if (this.position + 1 === this.lengthOfAttach) {
          this.$emit('click', this.getPostDirection())
        } else {
          this.selectDot(this.position + 1)
        }
      }
    },
    processSaveUserResponse: function (response) {
      this.total = 0
      this.answers = response.data.result.answers
      if (this.answers !== null) {
        this.answers.forEach((answer) => {
          this.total += answer.count
          this.optionTotal[answer.optionID] = answer.count
        })

        this.hasAnswers = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

.text {
  padding: 0 5rem;
  @include mobile {
    padding: 0 2rem;
  }
}

.polls {
  height: 100%;
  background-color: white;
  overflow-y: scroll;
  @include fix-ios-scrolling;
}

.forms {
  &_button {
    background-color: transparent;
    color: $secondary;
    margin: 20px 15px;
    padding: .625rem 1rem;
    border: 3px solid $secondary;
    border-radius: 5px;
    min-width: 150px;
    display: flex;
    flex-direction: column;
    font-size: .825em;
    font-weight: bold;
    &:hover, &-active {
      background-color: $secondary;
      color: white !important;
    }
  }
}

.dropdown-text {
  font-family: 'Roboto';
  font-size: 1rem;
}

.v-select {
  ::placeholder {
    color: #A1A1A1;
    font-family: 'Roboto';
    font-size: 1rem;;
  }
}

.content-area {
  margin-top:5%;
  margin-bottom:5%;
  width: 100%;
  padding-bottom: 1rem;
  background-color: white;
  @include touch {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }
}

.content-area-form {
  width: 60%;
  margin: 10rem auto 12rem auto;
}

::v-deep .vs__dropdown-menu {
  max-height: 175px;
  overflow-y: scroll;
}

::v-deep .vs__dropdown-toggle {
  padding: 8px;
}

.selection-area {
  font-size: 1.2rem;
  padding: 1rem;
  transition: all 0.5s;
  @include mobile {
    padding-bottom: 0.5rem;
  }
  &:hover {
    color: $secondary;
  }
}
.checkmark {
  padding: 0.6rem 1rem 0rem 2rem;
  @include touch {
    padding-top: 0.3rem;
    padding-left: 1rem;
  }
}

.save-button {
  margin: 2rem;
}

.progress {
  width: 600px;
  margin-bottom: 0;
  @include touch {
    width: 250px;
  }
  @include mobile {
    width: 200px;
  }
}

.progress-text {
  width: 500px;
  @include touch {
    width: 250px;
  }
  @include mobile {
    width: 200px;
  }
}

.percent {
  display: flex;
  align-items: flex-start;
  padding-left: 3rem;
  width: 9rem;
  font-size: 1.2rem;
  line-height: 13px;
  @include mobile {
    padding-left: 1rem;
    width: 6.5rem;
    font-size: 1.8rem;
  }
}
.total {
  display: flex;
  font-size: 1rem;
  line-height: 5px;
  float: right;
  @include mobile {
    padding-left: 1rem;
    width: 6.5rem;
    font-size: 1.8rem;
  }
}
.total-results {
  margin-right: 3rem;
  float: right;
}
.title {
  font-size: 1.7rem;
  text-align: center;
  padding:1.5rem;
  margin:0;
  @include mobile {
    font-size: 1.5rem;
  }
}

.loader {
  font-size: 3rem;
  margin: 2rem auto;
}
.loader-container {
  padding-bottom: 1rem;
}

.answer {
  margin-top: 1rem;
  margin-bottom: 2.5rem;
}

.results {
  @include mobile {
    margin-bottom: 5rem;
  }
}
  .button.is-primary {
    background-color: $secondary
  }
  .required-fields {
    position: absolute;
    right: 20px;
    top: 30px;
    font-size: 0.75rem;
  }
</style>
